import ConversationItemParts from 'owa-mail-store/lib/store/schema/ConversationItemParts';
import loadConversation, { LOAD_MORE_INCREMENT } from './loadConversation';
import mailStore from 'owa-mail-store/lib/store/Store';
import { action, select } from 'satcheljs/lib/legacy';
import { ObservableMap } from 'mobx';

export interface LoadMoreState {
    conversations: ObservableMap<string, ConversationItemParts>;
}

export default action('loadMore')(
    select<LoadMoreState>({
        conversations: () => mailStore.conversations,
    })(function loadMore(conversationId: string, state?: LoadMoreState) {
        if (state.conversations.has(conversationId)) {
            const conversationItemParts = state.conversations.get(conversationId);

            conversationItemParts.isLoadMoreInProgress = true;
            conversationItemParts.maxItemsToReturn =
                conversationItemParts.maxItemsToReturn + LOAD_MORE_INCREMENT;
            conversationItemParts.syncState = '';
            loadConversation(conversationId);
        }
    })
);
